import {SearchFormProps} from "../../common/searchForm/SearchForm.props";
import {OptionType} from "../../common/searchForm/constants/Option.type";
import {StatusTypeList} from "./Status.type";

export const LectureSearchFormProps: SearchFormProps = {
    options: [
        {
            type: OptionType.CHECK_LIST,
            name: "상태",
            key: "status",
            list: StatusTypeList.map(statusType => statusType.type),
            stringList: StatusTypeList.map(statusType => statusType.name),
            value: [true, true]
        },
        {
            type: OptionType.TEXT,
            key: "keyword",
            name: "검색",
            value: "",
            list: [],
            stringList: []
        }
    ],
    onSearch: () => {},
    onUpdate: () => {}
}